import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { MachineType } from '../types/machine-setup-types';

export class GetMachineTypesUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(): Promise<MachineType[]> {
    const response = await this.repository.getMachineTypes();
    if (!response.isSuccess) throw new Error(response.message || 'Failed to load machine types');
    return response.machineTypes ?? [];
  }
}
